enum InterceptorType {
  COMPOSITE = 'Composite',
  HTTP = 'HTTP',
  WEBRTC_AGENT = 'WebRTCAgent'
}

export default InterceptorType;
